function expandMenu(){
  var expandedMenu = document.getElementById("expandedMenu");

  document.addEventListener("click", function(e){
  const menuIconBtn = e.target.closest("#menuIcon");
  if(!menuIconBtn) return;    
  document.getElementById("menuIcon").addEventListener("click", () => {    
    
    
    var menuIcon = document.querySelector(".svgIcon-menu path");
    
    var menuText = document.getElementById("menuIcon");
    const l1Menu = expandedMenu.querySelector(".l1-menu");
    const backBtn = expandedMenu.querySelector(".back_menu-btn");
    expandedMenu.querySelectorAll("details[open]").forEach(openDetail => {
      openDetail.removeAttribute("open");
    });
        // Mobile View Menu
        if(expandedMenu.offsetWidth != 0){
            expandedMenu.getElementsByClassName("menu-header")['0'].style.display="none";
            expandedMenu.getElementsByClassName("menu-body")['0'].style.display="none";
            expandedMenu.style.width = "0";
            menuIcon.style.fill = "#fff";
            menuIcon.setAttribute("fill-rule", "evenodd");
            document.body.classList.remove('menu-expanded');
            menuText.getElementsByClassName('icon-label')[0].style.color="#fff";
            document.getElementById("modal-overlay_mob").style.display = "none";
            document.getElementById("modal-overlay_mob").style.zIndex = "-1";
            document.body.style.overflow = ''; 

            // header.style.backgroundColor = "rgba(0, 0, 0, 0)";
        }else{
            window.scrollTo(0, 0);
            expandedMenu.getElementsByClassName("menu-header")['0'].style.display="block";
            expandedMenu.getElementsByClassName("menu-body")['0'].style.display="block";
            expandedMenu.style.width = "100%";
            document.body.style.overflow = 'hidden';
            document.body.classList.add('menu-expanded');
            menuIcon.style.fill = "#FFD900";
            menuIcon.setAttribute("fill-rule", "nonzero");
            menuText.getElementsByClassName('icon-label')[0].style.color="#FFD900";
            document.getElementById("modal-overlay_mob").style.display = "block";
            document.getElementById("modal-overlay_mob").style.zIndex = "5";

            // header.style.backgroundColor = "white";

         
          expandedMenu.querySelectorAll(".l1-menu-item-wrapper").forEach(wrapper => {
            const summary = wrapper.querySelector("summary");
            if (summary) {
              summary.addEventListener("click", () => {
                setTimeout(() => {
                  if (wrapper.hasAttribute("open")) {
                    backBtn.style.visibility = "visible";
                  }
                }, 0); // wait for native toggle
              });
            }
          });
        
          backBtn.addEventListener("click", () => {            
             expandedMenu.querySelectorAll("details[open]").forEach(openDetail => {
                openDetail.removeAttribute("open");
              });
            backBtn.style.visibility = "hidden";
          });
        }
        expandedMenu.querySelector('.close_menu-btn').addEventListener("click", () => {
          expandedMenu.querySelectorAll("details[open]").forEach(openDetail => {
            openDetail.removeAttribute("open");
          });
        
          // Hide back button if it’s visible
          backBtn.style.visibility = "hidden";
          expandedMenu.classList.remove("mobile-menu_open");
          expandedMenu.classList.add("mobile-menu_close");
          expandedMenu.style.width = "0";
          menuIcon.style.fill = "#fff";
          menuIcon.setAttribute("fill-rule", "evenodd");
          // menuText.getElementsByTagName('span')[0].style.color="#fff";
          menuText.getElementsByClassName('icon-label')[0].style.color="#fff";
          document.getElementById("modal-overlay_mob").style.display = "none";
          document.body.style.overflow = ''; 
          document.body.classList.remove('menu-expanded');
          document.getElementById("modal-overlay_mob").style.zIndex = "-1";
          expandedMenu.getElementsByClassName("menu-header")['0'].style.display="none";
          expandedMenu.getElementsByClassName("menu-body")['0'].style.display="none";
        });
}); 
  expandedMenu.querySelectorAll('.l2-menu details').forEach(detailsEl => {
    detailsEl.addEventListener('toggle', function () {
      if (this.open) {      
        const siblings = this.parentElement.querySelectorAll('details');
        siblings.forEach(sibling => {
          if (sibling !== this && sibling.open) {
            sibling.removeAttribute('open');
          }
        });
      }
    });
  });
});
}

// function MobileExpandL2MenuOnL1Click(){
//     var mobileMenu = document.getElementsByClassName("mobile-menu")[0];
//     var l1MenuItems = mobileMenu.querySelectorAll(".l1-menu-item");
//     var l2MenuContainer = mobileMenu.querySelector("#l2MenuContainer");
//     var l3MenuContainer = mobileMenu.querySelector("#l3MenuContainer");
//     var menuIcon = document.querySelector(".svgIcon-menu path");
//     var closeButton = mobileMenu.querySelector(".close_menu-btn");
//     var menuText = document.getElementById("menuIcon");
//     var trackbackbutton ;

//     for (let i = 0; i < l1MenuItems.length; i++) {
//         const item = l1MenuItems[i];

//         item.addEventListener("click", () => {
//             var itemIdentifier = item.dataset.value;
//             var correspondingL2MenuContent = document.getElementById(itemIdentifier);
//             var backMenuBtn = document.querySelector(".back_menu-btn");
//             l2MenuContainer.innerHTML = correspondingL2MenuContent.innerHTML;
//             l2MenuContainer.style.width = "100%";
//             l2MenuContainer.querySelectorAll(".item-title").forEach(function(element) {
//                 element.style.display = "flex";
//             });
//             trackbackbutton = document.getElementById("mobile-menu_headertitle").innerHTML;
//             document.getElementById("mobile-menu_headertitle").innerHTML = itemIdentifier;
//             backMenuBtn.style.visibility="unset";
//             backMenuBtn.addEventListener("click", () => {
//                 if(l3MenuContainer.style.width == '0px' ){
//                     if (l2MenuContainer.offsetWidth != 0) {
//                         l2MenuContainer.querySelectorAll(".item-title").forEach(function(element) {
//                             element.style.display = "none";
//                         });
//                         l2MenuContainer.style.width = "0";
//                         document.getElementById("mobile-menu_headertitle").innerHTML = trackbackbutton;
//                         backMenuBtn.style.visibility="hidden";
//                     }
//                 }else{                
//                     l3MenuContainer.style.width = "0";
//                 }
//             });
//             MobileExpandL3MenuOnL2Click();
//         });
//     }

//     closeButton.addEventListener("click", () => {
//         if (l2MenuContainer.offsetWidth != 0) {
//             mobileMenu.getElementsByClassName("menu-body")['0'].style.display="none";
//             mobileMenu.getElementsByClassName("menu-header")['0'].style.display="none";
//             l2MenuContainer.style.width = "0";
//             if(trackbackbutton)
//                 document.getElementById("mobile-menu_headertitle").innerHTML = trackbackbutton;
//             else{
//                 trackbackbutton = document.getElementById("mobile-menu_headertitle").innerHTML;
//                 document.getElementById("mobile-menu_headertitle").innerHTML = trackbackbutton;
//             }

//             mobileMenu.style.width = "0";
//             document.body.style.overflow = ''; 
//             menuIcon.style.fill = "#fff";
//             menuIcon.setAttribute("fill-rule", "evenodd");
//             menuText.getElementsByClassName('icon-label')[0].style.color="#fff";
//             document.getElementById("modal-overlay_mob").style.display = "none";

//         }else{
//             mobileMenu.style.width = "0";
//             document.body.style.overflow = ''; 
//             menuIcon.style.fill = "#FFD900";
//             menuText.getElementsByClassName('icon-label')[0].style.color="#FFD900";
//             document.getElementById("modal-overlay_mob").style.display = "none";
//         }
//         document.body.classList.remove('menu-expanded');
//         document.getElementById("modal-overlay_mob").style.zIndex = "-1";
//     });
// }
// function MobileExpandL3MenuOnL2Click(){
//     var mobileMenu = document.getElementsByClassName("mobile-menu")[0];
//     var l2MenuItems = document.querySelectorAll(".l2-menu-item");
//     var l3MenuContainer = mobileMenu.querySelector("#l3MenuContainer");
//     var menuIcon = document.getElementsByClassName("svgIcon-menu")[0];
//     var closeButton = mobileMenu.querySelector(".close_menu-btn");
//     var menuText = document.getElementById("menuIcon");
//     var trackbackbutton ;

//     l2MenuItems.forEach(function(item) {
//         item.addEventListener("click", () => {
//             var itemIdentifier = item.dataset.value;
//             var correspondingL2MenuContent = document.getElementById(itemIdentifier);
//             l3MenuContainer.innerHTML = correspondingL2MenuContent.innerHTML;
//             l3MenuContainer.style.width = "100%";
//             l3MenuContainer.querySelectorAll(".item-title").forEach(function(element) {
//                 element.style.display = "block";
//             });
//             trackbackbutton = document.getElementById("mobile-menu_headertitle").innerHTML;
//             document.getElementById("mobile-menu_headertitle").innerHTML = itemIdentifier;
//         });
//     });

//     closeButton.addEventListener("click", () => {
//         if (l3MenuContainer.offsetWidth != 0) {
//             l3MenuContainer.style.width = "0";
//             if(trackbackbutton)
//                 document.getElementById("mobile-menu_headertitle").innerHTML = trackbackbutton;
//             mobileMenu.style.width = "0";
//             document.body.style.overflow = ''; 
//             // menuIcon.style.fill = "#fff";
//             // menuText.getElementsByTagName('span')[0].style.color="#fff";
//             document.getElementById("modal-overlay_mob").style.display = "none";

//         }else{
//             mobileMenu.style.width = "0";
//             document.body.style.overflow = ''; 
//             // menuIcon.style.fill = "#000";
//             // menuText.getElementsByTagName('span')[0].style.color="#000";
//             document.getElementById("modal-overlay_mob").style.display = "none";
//         }
//       document.body.classList.remove('menu-expanded');
//       document.getElementById("modal-overlay_mob").style.zIndex = "-1";
//     });
// }
function stickyHeaderOnScroll() {
    var header = document.getElementsByClassName("desktop-header")[0];
    var textLogo = document.getElementById("textLogo");
    var iconLogo = document.getElementById("iconLogo");
    
    if (header) {
        window.onscroll = function() {
            var sticky = header.offsetTop;

            if (window.pageYOffset > sticky) {
                textLogo.style.opacity = "0";
                iconLogo.style.opacity = "1";
            } else {
                textLogo.style.opacity = "1";
                iconLogo.style.opacity = "0";
            }
        };
    }
}
expandMenu();
// MobileExpandL2MenuOnL1Click();
stickyHeaderOnScroll();